import * as React from "react";
import MuiFormControlLabel, {
    FormControlLabelProps as MuiFormControlLabelProps,
    FormControlLabelClassKey as MuiFormControlLabelClassKey
} from "@material-ui/core/FormControlLabel";

export type FormControlLabelClassKey = MuiFormControlLabelClassKey;

export interface FormControlLabelProps extends MuiFormControlLabelProps { }

class FormControl extends React.PureComponent<FormControlLabelProps> {
    render() {
        const { ...props } = this.props;
        return <MuiFormControlLabel {...props}>
            {this.props.children}
        </MuiFormControlLabel>;
    }
}

export default FormControl; 